import { Autocomplete, TextField } from '@mui/material';
import CountryList from 'src/data/CountryList';

// "İstanbul" -> "istanbul", "Fransız" -> "fransiz" gibi normalize eder ki
// kullanıcı aksansız/küçük harfle yazdığında da eşleşme olsun.
const normalize = (text) =>
  String(text || '')
    .replace(/İ/g, 'i')
    .replace(/I/g, 'i')
    .replace(/ı/g, 'i')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

// Listede İngilizce ad gösterilir (DHL de İngilizce gösteriyor); arama yine
// Türkçe adla da çalışır — filterCountries üç alanda birden eşleştiriyor.
const getOptionText = (option) =>
  option ? `${option.name} (${option.code})` : '';

// Aranan metin ülke kodu, İngilizce ad veya Türkçe adın içinde geçiyorsa eşleşir.
// Baştan eşleşenler listenin başına alınır ("fr" -> önce Fransa).
const filterCountries = (options, { inputValue }) => {
  const query = normalize(inputValue).trim();
  if (!query) {
    return options;
  }

  const startsWith = [];
  const contains = [];

  options.forEach((option) => {
    const haystacks = [option.code, option.name, option.nameTr].map(normalize);
    if (haystacks.some((value) => value.startsWith(query))) {
      startsWith.push(option);
    } else if (haystacks.some((value) => value.includes(query))) {
      contains.push(option);
    }
  });

  return [...startsWith, ...contains];
};

// Ülke seçimi için ortak alan. Dışarıya ISO 3166-1 alpha-2 kodunu verir (örn. 'DE').
export default function CountryAutocomplete({
  label = 'Ülkesine',
  value,
  onChange,
  error,
  helperText,
  placeholder = 'Ülke seçin veya yazın',
  // true ise seçim yapıldıktan sonra input'ta yalnızca kod görünür ("TR");
  // açılır listede ülkeler yine tam adıyla listelenir.
  showCodeOnly = false,
  ...other
}) {
  const selected = CountryList.find((country) => country.code === value) || null;

  return (
    <Autocomplete
      fullWidth
      options={CountryList}
      value={selected}
      onChange={(_event, option) => onChange(option?.code || '')}
      getOptionLabel={showCodeOnly ? (option) => option?.code || '' : getOptionText}
      isOptionEqualToValue={(option, selectedOption) =>
        option.code === selectedOption?.code
      }
      filterOptions={filterCountries}
      noOptionsText="Sonuç bulunamadı"
      renderOption={(props, option) => (
        <li {...props} key={option.code}>
          {getOptionText(option)}
        </li>
      )}
      ListboxProps={{ style: { maxHeight: 280 } }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
        />
      )}
      {...other}
    />
  );
}
